
import { useState, useEffect } from "react";
import { useToast } from "@/hooks/use-toast";

interface BluejayGroup {
  id: string;
  name: string;
  description: string | null;
  created_at: string;
  deviceCount: number;
}

interface NewBluejayGroup {
  name: string;
  description: string | null;
}

export const useBluejayGroups = () => {
  const [groups, setGroups] = useState<BluejayGroup[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const { toast } = useToast();

  useEffect(() => {
    // Mock data for now - replace with Convex API when available
    setGroups([]);
    setIsLoading(false);
  }, []);

  const addGroup = async (newGroup: NewBluejayGroup) => {
    try {
      console.log('Adding Bluejay group:', newGroup);
      // Mock implementation - replace with Convex API
      const mockGroup: BluejayGroup = {
        id: Date.now().toString(),
        name: newGroup.name,
        description: newGroup.description,
        created_at: new Date().toISOString(),
        deviceCount: 0
      };
      setGroups(prev => [...prev, mockGroup]);
      
      toast({
        title: "Success",
        description: "Bluejay group created successfully",
      });
    } catch (error) {
      console.error('Error creating Bluejay group:', error);
      toast({
        title: "Error",
        description: "Failed to create Bluejay group",
        variant: "destructive",
      });
      throw error;
    }
  };

  return {
    groups,
    isLoading,
    addGroup
  };
};
